import { useEffect } from 'react'

import { loadIntercom } from '@/actions'
import { useAppDispatch } from '@/store'

export const useIntercomLoader = () => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(loadIntercom())
    }, [dispatch])
}
